
const desktopBreakPoint = 991; // Screen width in px
const mobileMenuSlideTime = 200; // ms
const drawerSlideInTime = 400; // ms
const drawerSlideOutTime = 300; // ms
const mobileCollectionStorySlideTime = 200; // ms
const transparentHeaderScrollTrigger = 200; // Pixels scrolled from top of viewport where transparent header becomes solid
var transparentHeader = false;
if ($('body').hasClass('transparent-header')) { // For pages with transparent header
  transparentHeader = true;
}
